(function ($, w, undefined) {

    function ScrollIcon(args) {
        this.defaults = {
            container: '',
            target: ''
        };

        this.options = $.extend(true, {}, this.defaults, args);
        this.$container = $(this.options.container);
        this.$target = $(this.options.target).first();

        if (this.$container.length === 0) {
            return;
        }

        if (this.$target.length === 0) {
            return;
        }

        var self = this;

        MCN.Utility.StateManager.addOnEnter('mobile', function () {
            self.$container.bind('click', function (e) {
                self.scrollDownForMobile(e, self);
            });
        });

        MCN.Utility.StateManager.addOnEnter('desktop', function () {
            self.$container.bind('click', function (e) {
                self.scrollDownForDesktop(e, self);
            });
        });
    }


    ScrollIcon.prototype.scrollDownForMobile = function (e, self) {
        e.preventDefault();
        var globalHeader = $('#global-header');
        var globalHeaderHeight = globalHeader.height();
        var position = 0;
        var $targetPosition = self.$target.position();

        if ($targetPosition !== null && $targetPosition.top > 0) {
            position = $targetPosition.top;

            // Reduce the fixed height of the global nav in mobile
            if (position > globalHeaderHeight) {
                position = position - globalHeaderHeight;
            }
        }

        if (position === 0) {
            return;
        }
        
        self.scrollDownToPosition(position);
    };

    ScrollIcon.prototype.scrollDownForDesktop = function (e, self) {
        e.preventDefault();
        var position = 0;
        var $targetPosition = self.$target.position();

        if ($targetPosition !== null && $targetPosition.top > 0) {
            position = $targetPosition.top;
        }

        if (position === 0) {
            return;
        }

        self.scrollDownToPosition(position);
    };


    ScrollIcon.prototype.scrollDownToPosition = function (position) {
        $('html, body').animate({
            scrollTop: position
        }, 500);
    };


    w.MCN = w.MCN || {};
    w.MCN.ScrollIcon = ScrollIcon;

})(jQuery, window);
